<template>
  <div class="personal-info">
    <div class="title">收件地址</div>
    <div class="form">
      <div class="form-line">
        <div class="form-left"><span>*</span>姓名：</div>
        <div class="form-right">
          <el-input v-model="addressInfo.consignee" placeholder="请输入姓名"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left"><span>*</span>手机号：</div>
        <div class="form-right">
          <el-input v-model="addressInfo.mobile" placeholder="请输入手机号"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">电子邮箱：</div>
        <div class="form-right">
          <el-input v-model="addressInfo.email" placeholder="请输入电子邮箱"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left"><span>*</span>收件地址：</div>
        <div class="form-right">
          <el-input type="textarea" v-model="addressInfo.address" placeholder="请输入收件地址"></el-input>
        </div>
      </div>
    </div>
    <div class="bottom-button">
      <div class="red-button" @click="saveContactInfo">保存资料</div>
      <div class="red-button" @click="resetContactInfo">重置信息</div>
    </div>
  </div>
</template>
<script>
  import userApi from '@/api/user'
  export default {
    data() {
      return {
        addressInfo    : {},
        addressInfoCopy: {}
      };
    },
    created() {
      this.$emit("getCompontsIndex", 3);
      this.getContactInfo();
    },
    methods: {
      // 获取用户收件信息
      async getContactInfo() {
        let {data} = await userApi.address.list()
        if(data.length > 0) {
          this.addressInfo = {...data[0]}
          this.addressInfoCopy = {...data[0]}
        }
      },
      // 保存资料
      async saveContactInfo() {
        this.addressInfo['is_default'] = 1
        if(this.addressInfo.id) {
          await userApi.address.update(this.addressInfo.id, this.addressInfo)
        } else {
          await userApi.address.create(this.addressInfo)
        }

        this.$message({
          message: '更新成功！',
          type: "success"
        });
        this.getContactInfo();
        
      },
      // 重置信息
      resetContactInfo() {
        this.addressInfo = {...this.addressInfoCopy};
      }
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>
